export default __webpack_public_path__ + "static/media/fire.ff95ec84.svg";